import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirdrop2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAirdrop2"><Path d="M7.5 21.5V16.5H16.5V21.5H7.5Z" stroke="currentColor"/><Path d="M13.5 16.25L20 11.25M4 11.25L10.5 16.25M12 10.5V16" stroke="currentColor" strokeLinecap="square"/><Path d="M12 2.5C7.30558 2.5 3.5 6.30558 3.5 11C3.5 11 8.67407 10.4688 12 10.4688C15.3259 10.4688 20.5 11 20.5 11C20.5 6.30558 16.6944 2.5 12 2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconAirdrop2;
